<template>
  <v-container class="ma-0 pa-0">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="add-organization-button"
          color="rgb(255, 149, 24)"
          dark
          fixed
          bottom
          right
          fab
          x-large
          link
          style="bottom: 1em;"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <addOrganizationModal
        @close="() => this.dialog = false"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import addOrganizationModal from './AddOrganizationModal'

export default {
  name: 'AddOrganizationButton',

  components: {
    addOrganizationModal
  },

  data: () => ({
    dialog: false
  })
}
</script>

<style lang="sass" scoped>

</style>
